import React from "react";
import { Link } from "react-router-dom";

export default function AboutPage() {
  return (
    <div className="max-w-5xl mx-auto px-6 lg:px-10 py-20">
      <div className="chip mb-6">About Pelico Data</div>
      <h1 className="font-display text-5xl sm:text-6xl font-bold tracking-tight">A digital workforce platform, reimagined.</h1>
      <p className="mt-6 text-lg text-zinc-600 leading-relaxed max-w-3xl">
        Pelico Data is a forward-thinking technology company empowering the next generation of digital operators. We connect remote talent
        with verified work — from data entry to typing certifications — through a transparent, growth-focused platform.
      </p>

      <div className="grid md:grid-cols-2 gap-6 mt-14">
        <div className="card-clean p-8">
          <div className="font-display text-2xl font-bold">Who We Are</div>
          <p className="mt-3 text-zinc-600 leading-relaxed">A multi-disciplinary team of engineers, designers, and operators building tools that respect your time and reward your work.</p>
        </div>
        <div className="card-clean p-8">
          <div className="font-display text-2xl font-bold">Our Mission</div>
          <p className="mt-3 text-zinc-600 leading-relaxed">To make remote, async work the default — not the exception — for millions of digital professionals worldwide.</p>
        </div>
        <div className="card-clean p-8">
          <div className="font-display text-2xl font-bold">What Makes Us Different</div>
          <p className="mt-3 text-zinc-600 leading-relaxed">Honest measurement, automated grading, real-time accuracy reports, and an admin console designed for scale.</p>
        </div>
        <div className="card-clean p-8">
          <div className="font-display text-2xl font-bold">Our Impact</div>
          <p className="mt-3 text-zinc-600 leading-relaxed">10,000+ operators trained, 1.2M+ pages graded, 98%+ average typing accuracy across the platform.</p>
        </div>
      </div>

      <div className="mt-16 card-clean p-10 bg-[var(--ink)] text-white text-center">
        <h3 className="font-display text-3xl font-bold">Join the journey.</h3>
        <p className="mt-3 text-zinc-300">Get started in less than 60 seconds.</p>
        <Link to="/login" style={{ background: "#fff", color: "#0b1f3a" }} className="mt-6 inline-flex items-center gap-2 px-6 py-3 rounded-full font-semibold">Sign In →</Link>
      </div>
    </div>
  );
}
